import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const Reports = lazy(() => import('./index'))

const reportsRoutes = [
    {
        path: '/reports',
        component: Reports,
        auth: authRoleAccess.reports_view,
    },
]

export default reportsRoutes
